import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { UserProfile } from '../../../models/user-profile';

/**
 * Summary
 *    Displays the user's profile information within a widget.
 *    
 *
 * Description
 *    Displays the user's profile information within a widget, can be used in multiple places.
 *
 * @copyright 2017 ReallyB2B Limited
 */
@Component({
  selector: 'app-profile-widget',
  templateUrl: './profile-widget.component.html',
  styleUrls: ['./profile-widget.component.scss']
})
export class ProfileWidgetComponent implements OnInit {
  // The current user's profile
  @Input() currentProfile: UserProfile = null;
  // Flag to determine if the data is still loading
  @Input() profilePending = false;

  /**
   * Constructor for page
   *
   * @param {Router} router Initialises Router object providing navigation between pages
   */
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  /**
   * Navigate the user to a given page
   *
   * @param {string} pageRef The page chosen to navigate to
   */
  goToPage(pageRef: string)
  {
    this.router.navigate([pageRef]);
  }
}
